import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { createSelector, Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { getOneClickStandardLot } from '@ordersnproducts/modules/one-click-order/selectors/one-click-standard-lot.selector';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { filter, take } from 'rxjs/operators';

const getStandardLotAndSelectedOrder = createSelector(
  getOneClickStandardLot,
  getOneClickSelectedOrder,
  (multipleStandardLot, order) => ({ multipleStandardLot, order }),
);

@Injectable()
export class OneClickSetStandardLotOrder implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getStandardLotAndSelectedOrder)
        .pipe(
          filter(({ multipleStandardLot, order }) => !!multipleStandardLot && !!order),
          take(1),
        )
        .subscribe(({ multipleStandardLot, order }) => {
          const modded: Order = {
            ...order,
            totalQuantity: value,
            items: order.items.map((item, index) => {
              if (index === form.mapItem['index']) {
                return {
                  ...item,
                  lot: {
                    lotMin: multipleStandardLot.lotMin,
                    conversionFactor: item && item.lot && item.lot.conversionFactor,
                  },
                  quantity: value,
                };
              } else {
                return item;
              }
            }),
          };
          this.store.dispatch(new OneClickUpdateOrderAction(modded));
        });
    }
  }
}
